export const getPositioning = (node: HTMLElement | Element) => {
  let tallestParent = node;

  while (tallestParent !== document.body) {
    const currentNode = tallestParent.parentNode as HTMLElement;
    if (currentNode) {
      const pos = getComputedStyle(currentNode).position;
      if (pos === 'absolute' || pos === 'fixed') {
        return true;
      }
      tallestParent = currentNode;
    }
  }
  return false;
};
